import React from "react";
import { cn } from "@/utils/cn";

export type StatCardProps = {
  stat: string;
  description: string;
  className?: string;
  statClassName?: string;
};

export type StatItem = {
  readonly value: string;
  readonly description: string;
};

export const StatCard: React.FC<StatCardProps> = ({
  stat,
  description,
  className,
  statClassName,
}) => (
  <div className={cn("flex flex-col gap-4 rounded-2xl bg-white p-6", className)}>
    <div className={cn("flex w-fit items-center justify-center rounded-[20px] p-4 bg-primary-50 text-primary-500", statClassName)}>
      <span className="headline-c-bold whitespace-nowrap">
        {stat}
      </span>
    </div>
    <p className="body-b-regular text-primary-900">{description}</p>
  </div>
);
